import React, { useEffect } from "react";

const CHAT_LOADER_SCRIPT_SRC =
  "https://joedown11-chatrag.hf.space/static/chat-loader.js";

const ChatBotLoader: React.FC = () => {
  useEffect(() => {
    if (
      document.querySelector(`script[src="${CHAT_LOADER_SCRIPT_SRC}"]`)
    ) {
      return;
    }
    const script = document.createElement("script");
    script.src = CHAT_LOADER_SCRIPT_SRC;
    script.async = true;
    document.body.appendChild(script);
  }, []);

  return null;
};

export default ChatBotLoader;
